import React, { useCallback, useEffect, useState } from 'react';
import { GetVoidPaginateObj, PaginateObj } from '../../types/Paginate/PaginateObjt';
import { AnunciosData } from '../../types/Anuncio/AnuncioData';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Container, Grid, Tab, Tabs, Typography } from '@mui/material';
import AnuncioService from '../../services/AnuncioService';
import { BarraBusqueda } from '../../common/Behelit/BarraBusqueda';
import { MisComunicadosTable } from '../../componente/Creador/MisComunicadosTable';
import { GetVoidSeguimientoByEstado, SeguimientoByEstado } from '../../types/Seguimiento/SeguimientoByEstado';
import SegumientoService from '../../services/SeguimientoService';
import { SpanX } from '../../common/Behelit/Span';
import { themePalette } from '../../config/theme.config';

export const MisComunicadosPage: React.FC<{}> = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const [tab, setTab] = useState(0);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState<PaginateObj<AnunciosData>>(GetVoidPaginateObj());
    const [seguimiento, setSeguimiento] = useState<SeguimientoByEstado>(GetVoidSeguimientoByEstado())

    const handleSearchChange = (value: string) => {
        setSearch(value);
    };
    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTab(newValue);
        //console.log(newValue);
    };

    const estadoAnuncios = (tab: number) => {
        let est = 'T';
        switch (tab) {
            case 1:
                est = 'R';
                break;
            case 2:
                est = 'P';
                break;
            case 3:
                est = 'A';
                break;
            case 4:
                est = 'U';
                break;
            case 5:
                est = 'E';
                break;
            case 6:
                est = 'B';
                break;
            default:
                break;
        }
        return est;
    }

    const fetchAnuncios = async () => {
        setLoading(true)
        try {
            const response = await AnuncioService.GetMisAnunciosPaginate(estadoAnuncios(tab));
            if (response.succeeded) {
                setPage(response)
            }

        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }

    const fetchAnunciosByTitle = async () => {
        setLoading(true)
        try {
            const response = await AnuncioService.GetMisAnunciosPaginateSearch(estadoAnuncios(tab), search);
            const data = response;
            // console.log(data);
            if (response.succeeded) {
                setPage(data);
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }
    const fetchSeguimiento = async () => {
        try {
            const response = await SegumientoService.GetVisited();
            // console.log(response)
            setSeguimiento(response);
        } catch (error) {
            console.error(error)
        }
    }
    useEffect(() => {
        fetchSeguimiento();
        fetchAnuncios();
    }, []);
    useEffect(() => {
        fetchAnuncios();
    }, [tab]);
    useEffect(() => {
        if (search.length === 0) {
            fetchAnuncios();
        }
        if (search.length < 3) return;
        const debounce = setTimeout(() => {
            fetchAnunciosByTitle();
        }, 500)
        function cleanup() {
            clearTimeout(debounce)
        }
    }, [search])

    return (
        <Container maxWidth="lg" style={{ padding: '20px', textAlign: 'center', marginTop: 10, border: `1px solid ${themePalette.NAVCOLOR}`, borderTopWidth: '3px', borderRadius: '5px' }}>
            <Box sx={{ display: 'flex' }}>
                <Typography variant="h4" gutterBottom style={{ fontWeight: 'bold', paddingBottom: '1%', color: `${themePalette.NAVCOLOR}` }}>
                    MIS COMUNICADOS
                </Typography>
            </Box>
            <Box sx={{ display: 'flex' }}>
                <Tabs
                    value={tab}
                    onChange={handleTabChange}
                    aria-label="Pestañas interactivas"
                    sx={{ borderBottom: 1, borderColor: 'divider' }}
                >
                    <Tab label={seguimiento.todos > 0 ? (<SpanX texto='Todos' numero={seguimiento.todos} />) : ("Todos")}  id="tab-0" aria-controls="tabpanel-0" />
                    <Tab label={seguimiento.rechazados > 0 ? (<SpanX texto={'Rechazados'} numero={seguimiento.rechazados} />) : ("Rechazados")} id="tab-1" aria-controls="tabpanel-1" />
                    <Tab label={"Enviados"} id="tab-2" aria-controls="tabpanel-2" />
                    <Tab label={seguimiento.aprobados > 0 ? (<SpanX texto='Aprobados' numero={seguimiento.aprobados} />) : ("Aprobados")} id="tab-3" aria-controls="tabpanel-3" />
                    <Tab label={seguimiento.publicados > 0 ? (<SpanX texto='Publicados' numero={seguimiento.publicados} />) : ("Publicados")} id="tab-4" aria-controls="tabpanel-4" />
                    <Tab label={("Expirados")} id="tab-5" aria-controls="tabpanel-5" />
                    <Tab label={("Borradores")} id="tab-6" aria-controls="tabpanel-6" />
                </Tabs>
            </Box>
            <Box sx={{ display: 'flex' }}>
                <BarraBusqueda id={"busqueda"} customStyles={{ m: 1, width: '100%' }} input={search} onChange={handleSearchChange} placeholder='Escriba una palabra del título'/>
            </Box>
            <Box sx={{ display: 'flex' }}>
                <Grid container spacing={2}>
                    {loading ? (
                        <CircularProgress />
                    ) : (
                        <MisComunicadosTable page={page} noHistorial={tab === 6} />
                    )}
                </Grid>
            </Box>
        </Container>

    )
}


